import { render, staticRenderFns } from "./CurrentBuild.vue?vue&type=template&id=47ae2dbe&scoped=true&"
import script from "./CurrentBuild.vue?vue&type=script&lang=ts&"
export * from "./CurrentBuild.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ae2dbe",
  null
  
)

export default component.exports